import React from "react";
import { RouteProps, Route, Redirect } from "react-router-dom";
import { useStore } from "../../store/useStore";
import AppMigrationRequired from "../../pages/Shared/AppMigrationRequired/AppMigrationRequiredPage";
import { DeferredLoadingFlags } from "../../util";
import { LoadingPage } from "../../pages/LoadingPage";

const AppMigrationRequiredRoute: React.FC<RouteProps> = ({
  children,
  ...props
}) => {
  const { state } = useStore();
  const { user } = state;

  if (state.loading.has(DeferredLoadingFlags.SILENT_AUTH))
    return <LoadingPage tip="Authenticating" />;
  if (!user) return <Redirect to="/login" />;

  /**
   * Migrated users from legacy system must complete wizard
   * in the mobile applications. Redirect to helpful error
   * page if they meet this condition.
   */
  if (user.attributes["custom:migrated"] === "t") {
    if (!state.ilivestockUser?.hasCompletedSetup) {
      return (
        <Route {...props} render={undefined}>
          <AppMigrationRequired />
        </Route>
      );
    } else {
      return <Redirect to="/" />;
    }
  }

  return <Route {...props} />;
};

export default AppMigrationRequiredRoute;
